module.exports = __webpack_public_path__ + "static/img/bankid-btn.53db6d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankid-btn.svg?data
// module id = a4p4
// module chunks = 1